import { io, type Socket } from 'socket.io-client';
import {
  SOCKET_PATH,
  type ClientToServerEvents,
  type ServerToClientEvents,
} from '@orbit-sync/shared-types';
import { API_BASE_URL } from './api/client.js';
import { getAccessToken } from './tokenStorage.js';

/**
 * Event maps are intentionally reversed relative to the server: what the server
 * sends is what this client receives.
 */
export type OrbitSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/**
 * Builds a socket carrying the access token in the Socket.IO handshake.
 *
 * The token goes in `auth`, not the query string: query strings end up in access
 * logs and proxy traces, and a bearer token in a log file is a credential leak.
 * The server reads it from exactly this field - see `realtime/socketAuth.ts`.
 *
 * Returned disconnected; the caller decides when to connect.
 */
export function createSocket(): OrbitSocket {
  return io(API_BASE_URL || window.location.origin, {
    path: SOCKET_PATH,
    // A function, so every reconnect handshakes with the CURRENT token - the
    // session keeper swaps it for a fresh one while the socket stays up.
    auth: (callback) => callback({ token: getAccessToken() ?? '' }),
    autoConnect: false,
    transports: ['websocket', 'polling'],
  });
}
